//bao migrate skip
import TabPage from "./tab-page";
import "./../bindings/bao-toolbar2";
import "./../bindings/foreach-selection";
import Bao from "./../services/bao-service";
import BaoDialog from "./bao-dialog";
import * as ko from "knockout";
import { BaseModel2 } from "../interfaces/base-model2";
import baoShouter from "../services/bao-shouter";
abstract class GenericListTab implements Factories.GenericListTab {
    constructor(tabPage: TabPage, parent: Factories.BaseViewModel2) {
        this.ControllerUrl = tabPage.Url();
        if (parent == null) {
            throw new Error("parent is not defined");
        }
        if (tabPage == null) {
            throw new Error("tabPage is not defined");
        }
        this.TabPage = tabPage;
        this.Parent = parent;
        this.IsLoading = tabPage.IsLoading;
        this.SessionTabId = this.Parent.TabPage.SessionTabId;
        this.Subscribe(this.TabPage.DirtyFlag, (isDirty) => {
            if (isDirty) {
                this.Parent.TabPage.DirtyFlag(true);
            }
        });
        this.Subscribe(this.PageIndex, () => {
            this.Get(false);
        });
        this.Subscribe(this.Sorting, () => {
            this.Get(false);
        });
        this.Subscribe(this.PageSize, () => {
            this.Get(true);
        });
        this.Subscribe(this.ToolbarButtons, () => {
            this.ToggleToolbarButtons();
        });
        this.Subscribe(this.Selection, () => {
            this.ToggleToolbarButtons();
        });
    }
    private _subscriptions: KnockoutSubscription[] = [];
    TabPage: TabPage;
    SessionTabId: string;
    ControllerUrl: string;
    MessageKeyRemove = "msgDelete";
    MessageKeyIsInUse = "msgIsInUse";
    MessageKeySaveCheck = "msgSaveCheck";
    PermissionAdd = "";
    PermissionEdit = "";
    PermissionRemove = "";
    ToolbarName: string = null;
    Parent: Factories.BaseViewModel2;
    IsLoading: KnockoutObservable<boolean>;
    PageSize = ko.observable(20);
    PageIndex = ko.observable(0);
    TotalRows = ko.observable(0);
    Selection = ko.observableArray([]);
    ToolbarButtons = ko.observableArray<Interfaces.Bao.BaoMenuItem>([]);
    Sorting = ko.observableArray<Models.Sorting>();
    Models = ko.observableArray<Models.BaseModel2>();
    abstract CustomFilter(): Models.HashObject[];
    abstract ItemCompleteCheck(item: any): JQueryPromise<boolean>;
    private _refreshInProgress: boolean = false;
    //Functions
    Subscribe<T>(obs: KnockoutObservable<T>, fn: (newValue?: T) => void) {
        this._subscriptions.push(obs.subscribe(fn));
    }
    GetParentId(): string {
        return ko.unwrap(this.Parent.PrimaryKeyValue);
    }
    Get(resetIndex = true): JQueryPromise<void> {
        let def = $.Deferred<void>();
        if (!this._refreshInProgress) {
            this._refreshInProgress = true;
            if (resetIndex) {
                this.PageIndex(0);
            }
            this.TabPage.IsLoading(true);
            Bao.post(this.UrlGet(), JSON.stringify({
                sessionTabId: this.SessionTabId,
                parentId: this.GetParentId(),
                customFilter: this.CustomFilter(),
                sorting: this.Sorting(), pageIndex: this.PageIndex(),
                pageSize: this.PageSize()
            }), (result: Factories.GenericListResponse.GetResponse) => {
                this.Models(result.Models);
                this.TotalRows(result.TotalRows);
            }).always(() => {
                this._refreshInProgress = false;
                this.TabPage.IsLoading(false);
                this.TabPage.DirtyFlag(false);
                def.resolve();
            });
        }
        else {
            def.resolve();
        }
        return def.promise();
    }
    Refresh(): JQueryPromise<void> {
        let def = $.Deferred<void>();
        this.Rollback().then(() => {
            this.Get().then(() => {
                def.resolve();
            });
        });
        return def.promise();
    }
    DialogWidth: number = null;
    Dialog(id: string): JQueryPromise<void> {
        this.TabPage.IsLoading(true);
        return Bao.post(this.UrlDialog(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: ko.unwrap(this.Parent.PrimaryKeyValue),
            id: id
        }), (result: Factories.GenericListResponse.DialogResponse) => {
            let dialog = new BaoDialog(Bao.Session.ApplicationName);
            let okButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
                let item = dialog.ViewModel();
                delete item.Parent;
                this.ItemCompleteCheck.call(this, item).then((validateResult) => {
                    if (validateResult) {
                        this.Save(ko.map.toJS(item)).then(() => {
                            this.TabPage.DirtyFlag(true);
                            dialog.Close();
                        });
                    }
                });
            });
            let cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                dialog.Close();
            });
            if (this.DialogWidth != null) {
                dialog.Width(this.DialogWidth + "px");
            }
            dialog.Buttons([okButton, cancelButton]);
            dialog.Template(result.Template);
            let vm = ko.map.fromJS(result.Model);
            vm.Parent = this;
            dialog.ViewModel(vm);
            dialog.Open(null);
            this.TabPage.IsLoading(false);
        });
    }
    Save(item: BaseModel2): JQueryPromise<void> {
        let def = $.Deferred<void>();
        this.TabPage.IsLoading(true);
        Bao.post(this.UrlSave(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            model: item
        }), () => {
            this.Get().then(() => {
                def.resolve();
            });
        });
        return def.promise();
    }
    Remove(itemIds: string[]): JQueryPromise<void> {
        let def = $.Deferred<void>();
        this.TabPage.IsLoading(true);
        Bao.post(this.UrlRemove(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            ids: itemIds
        }), () => {
            this.Get().then(() => {
                this.TabPage.DirtyFlag(true);
                def.resolve();
            });
        });
        return def.promise();
    }
    Commit(saveTime: string): JQueryPromise<void> {
        this.TabPage.IsLoading(true);
        return Bao.post(this.UrlCommit(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            version: saveTime
        }), () => {
            this.TabPage.DirtyFlag.reset();
        }).always(() => {
            this.TabPage.IsLoading(false);
        });
    }
    Rollback(): JQueryPromise<void> {
        this.TabPage.IsLoading(true);
        return Bao.post(this.UrlRollback(), JSON.stringify({ sessionTabId: this.SessionTabId })).always(() => {
            this.TabPage.IsLoading(false);
        });
    }
    BeforeRemove(itemIds: string[]): JQueryPromise<boolean> {
        if (this.UrlIsInUse() == "") {
            return this.BeforeRemoveQuestion();
        }
        else {
            let def = $.Deferred<boolean>();
            this.TabPage.IsLoading(true);
            Bao.post(this.UrlIsInUse(), JSON.stringify({
                sessionTabId: this.SessionTabId,
                ids: itemIds
            }), (inUseResult: Factories.GenericListResponse.InUseResponse) => {
                this.TabPage.IsLoading(false);
                if (!inUseResult.Result) {
                    this.BeforeRemoveQuestion().then((removeQuestionResult) => {
                        def.resolve(removeQuestionResult);
                    });
                }
                else {
                    new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(this.MessageKeyIsInUse), "info");
                    def.resolve(false);
                }
            });
            return def.promise();
        }
    }
    BeforeRemoveQuestion(): JQueryPromise<boolean> {
        let def = $.Deferred<boolean>();
        let yesNoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(this.MessageKeyRemove), "yesno");
        this.Subscribe(yesNoDialog.DialogResult, (dialogResult: boolean) => {
            def.resolve(dialogResult);
        });
        return def.promise();
    }
    CompleteCheck(): JQueryPromise<boolean> | boolean {
        return true;
    }
    BeforeClose(fn) {
        this.Dispose();
        fn();
    }
    Dispose() {
        for (const element of this._subscriptions) {
            element.dispose();
        }
        this._subscriptions = null;
    }
    //URLs
    UrlGet(): string {
        return this.ControllerUrl + "/Get";
    }
    UrlCommit(): string {
        return this.ControllerUrl + "/Commit";
    }
    UrlRollback(): string {
        return this.ControllerUrl + "/Rollback";
    }
    UrlDialog(): string {
        return this.ControllerUrl + "/Dialog";
    }
    UrlSave(): string {
        return this.ControllerUrl + "/Save";
    }
    UrlRemove(): string {
        return this.ControllerUrl + "/Remove";
    }
    UrlIsInUse(): string {
        return this.ControllerUrl + "/IsInUse";
    }
    UrlInit(): string {
        return this.ControllerUrl + "/Init";
    }
    ToggleToolbarButtons() {
        ko.utils.arrayForEach(this.ToolbarButtons(), (button) => {
            let key = ko.unwrap(button.ActionKey);
            let enabled = <KnockoutObservable<boolean>>(button.Enabled);
            if (key == this.PermissionEdit) {
                enabled(this.Selection() != null && this.Selection().length == 1);
            }
            else if (key == this.PermissionRemove) {
                enabled(this.Selection() != null && this.Selection().length > 0);
            }
        });
    }
    // draws an alert with the content of the given messagekey
    ShowAlert(messageKey, type?, duration: number = null) {
        if (!type) {
            type = 'success';
        }
        let message = Bao.Session.GetMessage(messageKey);
        if (message() !== "") {
            baoShouter.show(message(), type, duration);
        }
        else {
            let sub = message.subscribe((msg) => {
                baoShouter.show(msg, type, duration);
                sub.dispose();
            });
        }
    }
    init(): JQueryPromise<void> {
        this.TabPage.IsLoading(true);
        
        return Bao.post(this.UrlInit(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: this.GetParentId(),
            customFilter: this.CustomFilter(),
            sorting: this.Sorting(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize()
        }), (result: Factories.GenericListResponse.InitResponse) => {
            this.Models(result.Models);
            this.TotalRows(result.TotalRows);
            this.PermissionAdd = result.Definition.PermissionAdd;
            this.PermissionEdit = result.Definition.PermissionEdit;
            this.PermissionRemove = result.Definition.PermissionRemove;
            this.BindingToolbar.formName = result.Definition.FormName;
            this.BindingToolbar.applicationId = result.Definition.ApplicationId;
            this.TabPage.Title(result.Definition.TabTitle);
            this.TabPage.DirtyFlag.reset();
        }).always(() => {
            this.TabPage.IsLoading(false);
        });
    }
    //events 
    ToolbarClick = (button: Interfaces.Bao.BaoMenuItem) => {
        let key = ko.unwrap(button.ActionKey);
        switch (key) {
            case this.PermissionAdd:
                this.Dialog.call(this, null);
                break;
            case this.PermissionEdit:
                if (this.Selection() != null && this.Selection().length == 1) {
                    this.Dialog.call(this, ko.unwrap(this.Selection()[0].PrimaryKeyValue));
                }
                break;
            case this.PermissionRemove:
                if (this.Selection() != null && this.Selection().length > 0) {
                    let selectedIds = this._getIdFromSelection();
                    this.BeforeRemove.call(this, selectedIds).then((proceed) => {
                        if (proceed) {
                            this.Remove.call(this, selectedIds)
                                .then(() => {
                                    //reset selection, because the selection is removed now
                                    this.Selection([]);
                                });
                        }
                    });
                }
                break;
            default:
                this.CustomToolbarClick(button);
                break;
        }
    }
    CustomToolbarClick(button: Interfaces.Bao.BaoMenuItem) {
        //dummy!
    }
    private _getIdFromSelection(): string[] {
        let result: string[] = [];
        ko.utils.arrayForEach(this.Selection(), (item) => {
            result.push(ko.unwrap(item.PrimaryKeyValue));
        });
        return result;
    }
    //Bindings
    BindingToolbar: Bindings.baoToolbar2 = {
        buttons: this.ToolbarButtons,
        click: this.ToolbarClick,
        toolbarName: this.ToolbarName,
        formName: null,
        applicationId: null
    }
    BindingForeachSelection: Bindings.foreachSelection = {
        data: this.Models,
        mode: 'multi',
        pk: 'PrimaryKeyValue',
        selection: this.Selection
    }
}
export default GenericListTab;